import { TemplatePageCategoryModel } from "@domain-group/realhub-backend-api-types"
const state = {
  allow_category_mix: false,
  brand_id: undefined,
  global: false,
  hidden: false,
  id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'brand_id', validation: (brandId: number, { global }: TemplatePageCategoryModel) => global || !!brandId },
]

export default state
